import { FormGroup, Switch } from "@blueprintjs/core";
import { ItemSelect } from "@package/ui-apollo-components";
import {
  ActionPayloadType,
  GetPostListNameIdDocument,
  type GetPostListNameIdQuery,
  type GetPostListNameIdQueryVariables,
} from "@package/ui-gql/index-data-access";
import { type SchedulerEditActionProps } from "./scheduler-edit-action-props";

export function SchedulerEditActionEnablePost({
  action,
  disabled,
  onChange,
}: SchedulerEditActionProps) {
  if (
    action?.type == ActionPayloadType.ActionPostEnabled &&
    action?.__typename === "ActionPayloadPostEnabled"
  ) {
    return (
      <>
        <FormGroup disabled={disabled} label="Content">
          <ItemSelect<GetPostListNameIdQuery, GetPostListNameIdQueryVariables>
            activeItemId={action.post}
            disabled={disabled}
            document={GetPostListNameIdDocument}
            nullable={false}
            onItemSelected={(id) => {
              if (id) {
                onChange({
                  ...action,
                  post: id,
                });
              }
            }}
          />
        </FormGroup>
        <div className="w-full mt-6">
          <Switch
            disabled={disabled}
            label="Enable Content"
            checked={!!action?.enabled}
            onChange={() =>
              onChange({
                ...action,
                enabled: !action?.enabled,
              })
            }
          />
        </div>
      </>
    );
  }

  return null;
}
